import { Module } from 'vuex'
import { IRootState, IEventsState } from '@/@types'
import state from './state'
import actions from './actions'
import mutations from './mutations'

const events: Module<IEventsState, IRootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default events
